<div class="row amount-wrapper amount-extra-wrapper" *ngIf="extraAmount">
	<div class="column small-12 extra-amount" [formGroup]="form">
		<div class="checkboxbutton-wrapper">
			<input type="checkbox" value="1" id="has_extra_amount" formControlName="extra_amount" [attr.checked]="extraAmountActive" (change)="toggleExtraAmount(form.controls['extra_amount'].value)">
			<label for="has_extra_amount" ><span>{{'amount.extra.label' | translate: {amount: (extraAmountMoney | number: '1.2-2'), currency: donation.currencySymbol, percent: (extraAmountPercent | number: '1.0-2')} }}</span></label>
		</div>
	</div>
</div>
